/**
 * Mensagens centralizadas para o fluxo de Formas de Cobrança.
 * Usado no header, tooltips e getters de aviso.
 */
export default Object.freeze({
  NO_METHOD:
    'Você ainda não selecionou uma forma de pagamento. Acesse o perfil da empresa > Formas de Cobrança',
  PENDING_INVOICE:
    'Você possui uma fatura em aberto, acesse o perfil da empresa > Formas de Cobrança. Caso já tenha realizado o pagamento, o mesmo será processado em até 2 (dois) dias úteis',
  TOOLTIP_WARNING:
    'Verifique o perfil da empresa > Formas de Cobrança. Você ainda não selecionou uma forma de pagamento ou possui pendências',
});
